import React from "react";

import { DirectionsWrap, GroupTitle } from "components/RecipeSteps/Preview/styled";
import { DirectionMask, MaskWrapper, ButtonWrap } from "./styled";
import { LineDisplay } from "styles/General.styled";
import Button from "shared/Button";
import { colors } from "styles/colors";

const Directions = ({ paid, directions, purshased, showPayment, isPrivate }) => {
  return (
    <>
      {!purshased && paid ? (
        <>
          <MaskWrapper>
            <DirectionMask width={20}></DirectionMask>
            <DirectionMask width={100}></DirectionMask>
            <DirectionMask width={90}></DirectionMask>
          </MaskWrapper>
          <MaskWrapper>
            <DirectionMask width={20}></DirectionMask>
            <DirectionMask width={100}></DirectionMask>
            <DirectionMask width={90}></DirectionMask>
          </MaskWrapper>
          <MaskWrapper>
            <DirectionMask width={20}></DirectionMask>
            <DirectionMask width={100}></DirectionMask>
            <DirectionMask width={90}></DirectionMask>
          </MaskWrapper>
          {!isPrivate && (
            <ButtonWrap>
              <LineDisplay>
                <Button
                  color={colors.WHITE}
                  textColor={colors.RED}
                  stylType="secondary"
                  text="Buy to see full recipe"
                  iconRight="arrow_down"
                  btnSize="largre"
                  onClick={showPayment}
                />
              </LineDisplay>
            </ButtonWrap>
          )}
        </>
      ) : (
        directions &&
        directions.map((el) => {
          return (
            <React.Fragment key={el.id}>
              {directions.length > 1 && <GroupTitle>{el.name}</GroupTitle>}
              {el.direction.map((item) => {
                return (
                  <DirectionsWrap key={item.id}>
                    <GroupTitle>Step {item.number}</GroupTitle>
                    {item.description && item.description.split("\n").map((val, i) => <p key={i}>{val}</p>)}
                  </DirectionsWrap>
                );
              })}
            </React.Fragment>
          );
        })
      )}
    </>
  );
};
export default Directions;
